import { cn } from '@c2fo/liquidity';

interface UserAvatarProps {
  initials: string;
  size?: 'md' | 'lg';
}

const UserAvatar = ({ initials, size = 'md' }: UserAvatarProps) => (
  <div
    className={cn(`flex shrink-0 items-center justify-center rounded-full bg-purple-500`, {
      'size-11 font-medium': size === 'md',
      'size-14 text-xl': size === 'lg',
    })}
  >
    {initials}
  </div>
);

export default UserAvatar;
